.circle {
  outline: none;
}
